var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'status-tag': true, [_vm.lead.status ?? _vm.lead.status] : true }},[_vm._v(_vm._s(_vm._f("ucwords")(_vm.lead.status ?? _vm.lead.status)))])
}
var staticRenderFns = []

export { render, staticRenderFns }